export default "__VITE_ASSET__B9vk7wv7__"